module.exports = __webpack_public_path__ + "img/card-ai.034b0c02.svg";